export default __webpack_public_path__ + "static/media/Learnbutton2.90d8926c.png";